// Generated by CoffeeScript 2.3.1
let Config;

// import Vue from 'vue';

Config = function() {
  class Config {
    constructor() {
      // new Vue({
      //   data: this
      // });
      this.load();
    }

    load() {
      var cfgstr;
      cfgstr = localStorage.getItem("config");
      if (cfgstr) {
        return (this.cfg = JSON.parse(cfgstr));
      } else {
        this.cfg = JSON.parse(JSON.stringify(this.default));
        return this.save();
      }
    }

    save() {
      return localStorage.setItem("config", JSON.stringify(this.cfg));
    }

    get(key) {
      return this.cfg[key];
    }
  }

  Config.prototype.cfg = {};

  Config.prototype.default = {
    spreadsheet: {
      hide: {}
    }
  };

  return Config;
}.call(this);

export default new Config();

// module.exports = new Config()
